var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgSleep(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5926 9.57579H11.1869C11.1869 7.55979 8.75944 6.25693 6.66115 6.25693C5.31715 6.25693 4.24744 6.72322 3.84972 7.31293V5.11865C3.84972 4.32322 3.30116 3.85693 2.54687 3.85693C1.8063 3.85693 1.28516 4.41922 1.28516 5.15979V18.5869C1.28516 19.4098 1.79258 19.9721 2.5743 19.9721C3.39715 19.9721 3.93201 19.3138 3.93201 18.5321V16.8178H20.1406V18.5869C20.1406 19.4372 20.6617 19.9721 21.4434 19.9721C22.2526 19.9721 22.6777 19.3412 22.6777 18.5732V13.4175C22.6777 11.0175 20.9497 9.5775 18.5909 9.5775L18.5926 9.57579Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2628 9.57617C11.2628 10.8242 9.56227 11.2905 7.68341 11.2905C5.85941 11.2905 4.25484 10.7693 3.95312 10.0973"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0625 13.4629H22.5082"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleep);
export default __webpack_public_path__ + "static/media/sleep.9db0bbe479d5c9d86c9596514da69466.svg";
export { ForwardRef as ReactComponent };